import PropTypes from 'prop-types';
import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthGuard = ({ children, route }) => {
  if (!route.accessible) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
  route: PropTypes.object,
};

export default AuthGuard;
